import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePsiModel } from "../psiModel";
import { IPsiDetail } from "../psiService";
import { formatNum } from "@/utils/utils";
import YhTootip from "@/components/YhTootip";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading, descTotal,
        loadData, setSelectedRowKeys, onOpen
    } = usePsiModel();

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<IPsiDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '物料编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '物料名称',
            width: 160,
            dataIndex: 'materialName',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '采购价格',
            width: 120,
            dataIndex: 'purchasePrice',
            render: (text) => '￥' + formatNum(text)
        }, {
            title: '最新进价',
            width: 120,
            dataIndex: 'purchasePriceLatest',
            render: (text) => '￥' + formatNum(text)
        }, {
            title: '最新库存成本',
            width: 120,
            dataIndex: 'stockCostLatest',
            render: (text) => '￥' + formatNum(text)
        }, {
            title: '当前库存数',
            width: 120,
            dataIndex: 'currentNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "当前库存数",
                field: "currentNum"
            })}>{text}</span>,
        }, {
            title: '库存成本',
            width: 120,
            dataIndex: 'stockCost',
            render: (text) => '￥' + formatNum(text)
        }, {
            title: '进销存剩余数',
            width: 120,
            dataIndex: 'remainNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "进销存剩余数",
                field: "remainNum"
            })}>{text}</span>,
        }, {
            title: '差异数',
            width: 120,
            dataIndex: 'differenceNum',
        }, {
            title: '采购数(含期初和补偿)',
            width: 160,
            dataIndex: 'purhcaseNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "采购数",
                field: "purhcaseNum",
                type: "io_spd"
            })}> {text}</span >,
        }, {
            title: '期初数',
            width: 120,
            dataIndex: 'beginNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "startVisible",
            })}> {text}</span >,
        }, {
            title: '补偿数',
            width: 120,
            dataIndex: 'compensateNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "compensateVisible",
            })}> {text}</span >,
        }, {
            title: '采退退货数',
            width: 120,
            dataIndex: 'preturnNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "采退退货数",
                field: "preturnNum",
                type: "io_sprd"
            })}> {text}</span >,
        },
        {
            title: '借料数',
            width: 120,
            dataIndex: 'borrowNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "采退退货数",
                field: "borrowNum",
                type: "io_borrow"
            })}> {text}</span >,
        }, {
            title: '销售数',
            width: 120,
            dataIndex: 'saleNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "销售数",
                field: "saleNum",
                type: "io_ssd"
            })}> {text}</span >,
        }, {
            title: '销售退货数',
            width: 120,
            dataIndex: 'sreturnNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "销售退货数",
                field: "sreturnNum",
                type: "io_ssrd"
            })}> {text}</span >,
        }, {
            title: '维修用数',
            width: 120,
            dataIndex: 'maintainNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "维修用数",
                field: "maintainNum",
                type: "io_vmm"
            })}> {text}</span >,
        }, {
            title: '维修退数',
            width: 120,
            dataIndex: 'mreturnNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "remainVisible",
                title: "维修退数",
                field: "mreturnNum",
                type: "io_vrm"
            })}> {text}</span >,
        }, {
            title: '占用库存数',
            width: 120,
            dataIndex: 'occupyNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "occupyVisible",
                title: "占用库存数",
                field: "occupyNum",
            })}> {text}</span >,
        }, {
            title: '采退占用数',
            width: 120,
            dataIndex: 'preturnOccupyNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "occupyVisible",
                title: "采退占用数",
                field: "preturnOccupyNum",
                type: "occupy_prd"
            })}> {text}</span >,
        }, {
            title: '销售占用数',
            width: 120,
            dataIndex: 'saleOccupyNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "occupyVisible",
                title: "销售占用数",
                field: "saleOccupyNum",
                type: "occupy_ssd"
            })}> {text}</span >,
        }, {
            title: '维修占用数',
            width: 120,
            dataIndex: 'maintainOccupyNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "occupyVisible",
                title: "维修占用数",
                field: "maintainOccupyNum",
                type: "occupy_vmm"
            })}> {text}</span >,
        }, {
            title: '维修预约占用数',
            width: 120,
            dataIndex: 'bookOccupyNum',
            render: (text: any, record: any, index: number) => <span className="click-span" onClick={(e) => onOpen(record, {
                str: "occupyVisible",
                title: "维修预约占用数",
                field: "bookOccupyNum",
                type: "occupy_vam"
            })}> {text}</span >,
        }, {
            title: '占用差异',
            width: 120,
            dataIndex: 'occupyDifference',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }
    ];

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            loading={loading}
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id),
            //     onContextMenu: (e) => {
            //         e.preventDefault();
            //         setSelectedRowKeys([record.id]);
            //     }
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
            summary={() => (
                <Table.Summary fixed>
                    <Table.Summary.Row className="table-total-box">
                        <Table.Summary.Cell index={0}>
                            <div className="title">合计</div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} />
                        <Table.Summary.Cell index={4} />
                        <Table.Summary.Cell index={5} />
                        <Table.Summary.Cell index={6} >
                            <span className="green">{descTotal?.currentNumTotal}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8} />
                        <Table.Summary.Cell index={9} >
                            <span className="green">{descTotal?.differenceNumTotal}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={10} />
                        <Table.Summary.Cell index={11} />
                        <Table.Summary.Cell index={12} />
                        <Table.Summary.Cell index={13} />
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                        <Table.Summary.Cell index={18} />
                        <Table.Summary.Cell index={19} />
                        <Table.Summary.Cell index={20} />
                        <Table.Summary.Cell index={21} />
                        <Table.Summary.Cell index={22} />
                        <Table.Summary.Cell index={23} />
                        <Table.Summary.Cell index={24} >
                            <span className="green">{descTotal?.occupyDifferenceTotal}</span>
                        </Table.Summary.Cell>
                    </Table.Summary.Row>
                </Table.Summary>
            )}
        />
    )
}